import "../../../styles/org-buttons.css";
import { buttonText } from "../../../utils/buttonText";

function UploadPage(props) {
  const { goToMntPage, goToLocalPage } = props;

  return (
    <div className="acquisition-upload-page">
      <button type="button" className="org-btn org-btn-secondary" onClick={goToMntPage}>
        {buttonText("/mnt")}
      </button>
      <button type="button" className="org-btn org-btn-secondary" onClick={goToLocalPage}>
        {buttonText("Local")}
      </button>
    </div>
  );
}

export default UploadPage;
